<i18n>
{
  "fr": {
    "total-luggage-sentence": {
      "LuggageOptions": "Vous n'avez pas de bagages en option pour votre trajet. | Vous avez un bagage en option pour votre trajet. {weight}. | Vous avez {n} bagages en option pour votre trajet. {weight}.",
      "OutwardLuggageOptions": "Vous n'avez pas d'option de bagages pour l'aller. | Vous avez un bagage en option pour l'aller. {weight}. | Vous avez {n} bagages en option pour l'aller. {weight}.",
      "ReturnLuggageOptions": "Vous n'avez pas d'option de bagages pour le retour. | Vous avez un bagage en option pour le retour. {weight}. | Vous avez {n} bagages en option pour le retour. {weight}."
    }
  },
  "en": {
    "total-luggage-sentence": {
      "LuggageOptions": "You have no luggage option for your trip. | You have one bag in option for your trip. {weight}. | You have {n} bags in option for your trip. {weight}.",
      "OutwardLuggageOptions": "You have no luggage option for the outward. | You have one bag in option for the outward. {weight}. | You have {n} bags in option for the outward. {weight}.",
      "ReturnLuggageOptions": "You have no luggage option for the return. | You have one bag in option for the return. {weight}. | Vous avez {n} bags in option for the return. {weight}."
    }
  }
}
</i18n>

<template>
  <span>
    {{ totalLuggageSentence }}
  </span>
</template>

<script>
import _ from 'lodash'
import luggageOptionsMixin from '@/mixins/luggageOptions'

export default {
  name: 'TotalLuggageSentence',
  mixins: [luggageOptionsMixin],
  props: {
    optionsParams: {
      type: Object,
      default: null
    },
    optionKey: {
      type: String,
      required: true
    }
  },
  computed: {
    totalLuggageSentence () {
      // this.optionKey prop is LuggageOptions || OutwardLuggageOptions || ReturnLuggageOptions
      const selectedTotalQuantity = this.optionsParams?.[this.optionKey]?.selected_value?.quantity.split(' ')[0]
      const selectedTotalWeight = this.formatLuggageWeightDetails(this.optionsParams?.[this.optionKey]?.selected_value?.weight)
      // Take included luggage option from options list
      const includedLuggage = _.sortBy(this.optionsParams?.[this.optionKey]?.options.filter(option => !option.amount), ['option']).pop()

      if (selectedTotalQuantity) {
        return this.$i18n.tc(`total-luggage-sentence["${this.optionKey}"]`, selectedTotalQuantity, { weight: '\xa0' + selectedTotalWeight })
      } else if (includedLuggage) {
        return this.$i18n.tc(`total-luggage-sentence["${this.optionKey}"]`, includedLuggage.quantity.split(' ')[0], { weight: '\xa0' + this.formatLuggageWeightDetails(includedLuggage.weight) })
      } else {
        return this.$i18n.tc(`total-luggage-sentence["${this.optionKey}"]`, 0)
      }
    }
  }
}
</script>

<style scoped>
</style>
